import "./ListingNoResultMessage.scss";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import { FormattedMessage } from "react-intl";
import AlertMessage from "app/pages/.shared/AlertMessage";
import { memo } from "react";

const ListingNoResultMessage = () => {
	return (
		<div className="listing-no-result-message">
			<div className="listing-no-result-message__container">
				<Typography
					variant={TYPOGRAPHY_VARIANTS.XL2}
					isBold
					className="listing-no-result-message__title"
					data-testid="sdp-listing-error-title"
					component="div"
				>
					<FormattedMessage id="product.page.list.search.no.result" />
				</Typography>

				<div className="listing-no-result-message__text">
					<FormattedMessage id="sdp.list.search.update.preferences.label" />
				</div>

				<AlertMessage
					message={<FormattedMessage id="sdp.list.search.children.birthdates.warning" />}
				/>
			</div>
		</div>
	);
};

export default memo(ListingNoResultMessage);
